import {styledByTheme} from "../../../../../../../themes/architecture/styled-by-theme";
import {LiveCasinoGridItemInfoItemDefaultBox} from "./live-casino-grid-item-info-item.default.box";
import {LiveCasinoGridItemInfoItemSIBox} from "./live-casino-grid-item-info-item.si.box";

export const LiveCasinoGridItemInfoItemBox = styledByTheme(LiveCasinoGridItemInfoItemDefaultBox)
    .forSI(LiveCasinoGridItemInfoItemSIBox)
    .apply();